module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/index.js":
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! exports provided: MultistepForm, FormStep, FormState, NextButton */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultistepForm", function() { return MultistepForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormStep", function() { return FormStep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormState", function() { return FormState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NextButton", function() { return NextButton; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
var _jsxFileName = '/home/anxo/Development/multistep-form/src/index.js',
    _this3 = undefined;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var _React$createContext = react__WEBPACK_IMPORTED_MODULE_0___default.a.createContext({}),
    FormStateProvider = _React$createContext.Provider,
    FormState = _React$createContext.Consumer;

var MultistepForm = function (_React$Component) {
  _inherits(MultistepForm, _React$Component);

  function MultistepForm(props) {
    var _this2 = this;

    _classCallCheck(this, MultistepForm);

    var _this = _possibleConstructorReturn(this, (MultistepForm.__proto__ || Object.getPrototypeOf(MultistepForm)).call(this, props));

    _this.handleJump = function (next, noValidate) {
      return function (e) {
        if (noValidate) {
          // Don't save anything, just do the jump.
          e.preventDefault();

          if (next > _this.props.steps) {
            // Jumped after form end => submit
            _this.props.onSubmit && _this.props.onSubmit(data);
          } else {
            // Normal step transition
            _this.setState({ step: next });
          }
        } else {
          // Do a submit, but set next step to next (only during this submit)
          _this.jumpTo = next;
          window.setTimeout(function () {
            // This runs after the submit handler; we clear the mark afterwards
            delete _this.jumpTo;
          }, 0);
        }
      };
    };

    _this.handleSubmit = function (e) {
      e.preventDefault();

      // Add current elements to data
      var data = Object.assign({}, _this.state.data);
      var elements = Array.from(e.target.elements);
      elements.forEach(function (element) {
        var name = element.name;
        if (!name) return;
        switch (element.type) {
          case 'checkbox':
            data[name] = element.checked;
            break;
          case 'radio':
            if (element.checked) data[name] = element.value;
            break;
          case 'file':
            data[name] = element.files;
            break;
          default:
            data[name] = element.value;
        }
      });

      // Save data and advance one step (or to where specified with handleJump)
      var patch = { data: data };
      var nextStep = _this.state.step + 1;
      if (_this.jumpTo || _this.jumpTo === 0) {
        nextStep = _this.jumpTo;
      }
      if (nextStep <= _this.props.steps) {
        patch['step'] = nextStep;
      }
      _this.setState(patch);

      // If done, call onSubmit
      if (nextStep > _this.props.steps) {
        _this.props.onSubmit && _this.props.onSubmit(data);
      }
    };

    _this.render = function () {
      var _this$props = _this.props,
          steps = _this$props.steps,
          onSubmit = _this$props.onSubmit,
          other = _objectWithoutProperties(_this$props, ['steps', 'onSubmit']);

      var ctx = Object.assign({}, _this.state, { jump: _this.handleJump });
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        FormStateProvider,
        { value: ctx, __source: {
            fileName: _jsxFileName,
            lineNumber: 86
          },
          __self: _this2
        },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
          'form',
          Object.assign({}, other, { onSubmit: _this.handleSubmit, ref: _this.theForm, __source: {
              fileName: _jsxFileName,
              lineNumber: 87
            },
            __self: _this2
          }),
          _this.props.children
        )
      );
    };

    _this.state = { step: 1, data: {} };
    return _this;
  }

  return MultistepForm;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);

MultistepForm.propTypes = {
  steps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number.isRequired,
  onSubmit: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.any
};


var FormStep = function FormStep(_ref) {
  var step = _ref.step,
      steps = _ref.steps,
      condition = _ref.condition,
      children = _ref.children,
      nowrap = _ref.nowrap,
      other = _objectWithoutProperties(_ref, ['step', 'steps', 'condition', 'children', 'nowrap']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    FormState,
    {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 96
      },
      __self: _this3
    },
    function (_ref2) {
      var currentStep = _ref2.step,
          data = _ref2.data;

      var show = true;
      if (step && step !== currentStep) show = false;
      if (steps && steps.indexOf(currentStep) === -1) show = false;
      if (condition && !condition({ data: data })) show = false;
      if (show) {
        if (nowrap) {
          return children;
        } else {
          return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
            'div',
            Object.assign({}, other, {
              __source: {
                fileName: _jsxFileName,
                lineNumber: 106
              },
              __self: _this3
            }),
            children
          );
        }
      }
    }
  );
};

FormStep.propTypes = {
  step: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  steps: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number),
  condition: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.any,
  nowrap: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
};

var NextButton = function NextButton(_ref3) {
  var next = _ref3.next,
      noValidate = _ref3.noValidate,
      children = _ref3.children,
      other = _objectWithoutProperties(_ref3, ['next', 'noValidate', 'children']);

  return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
    FormState,
    {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 122
      },
      __self: _this3
    },
    function (_ref4) {
      var jump = _ref4.jump;
      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(
        'button',
        Object.assign({ type: 'submit' }, other, { onClick: jump(next, noValidate), __source: {
            fileName: _jsxFileName,
            lineNumber: 124
          },
          __self: _this3
        }),
        children
      );
    }
  );
};

NextButton.propTypes = {
  next: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
  noValidate: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.any
};



/***/ }),

/***/ "prop-types":
/*!*****************************!*\
  !*** external "prop-types" ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ })

/******/ });
//# sourceMappingURL=main.js.map